import {
  ChatCommentInterface,
  CommentCreateInterface,
  MessageCommentInterface, ReviewCommentInterface,
} from '@/services/QC-V2/chat/interfaces';
import { FeedbackCommentInterface } from '@/services/QC-V2/feedback/interfaces';
import { ReplyCommentInterface, TicketCommentInterface } from '@/services/QC-V2/ticket/interfaces';

export enum CommentRate {
  NOT_RATED,
  RATED_BAD,
  RATED_GOOD,
}

export interface CommentRepositoryInterface {
  /// CHAT
  createChatComment(id: string, data: CommentCreateInterface): Promise<ChatCommentInterface>;

  updateChatComment(chatId: string, commentId: number, data: CommentCreateInterface): Promise<void>;

  deleteChatComment(chatId: string, commentId: number): Promise<void>;

  /// MESSAGE
  createMessageComment(id: number, data: CommentCreateInterface): Promise<MessageCommentInterface>;

  updateMessageComment(messageId: number, commentId: number, data: CommentCreateInterface): Promise<void>;

  deleteMessageComment(messageId: number, commentId: number): Promise<void>;

  /// REVIEW
  createChatReviewComment(reviewId: number, data: CommentCreateInterface): Promise<ReviewCommentInterface>;

  createTicketReviewComment(reviewId: number, data: CommentCreateInterface): Promise<ReviewCommentInterface>;

  updateChatReviewComment(reviewId: number, commentId: number, data: CommentCreateInterface): Promise<void>;

  updateTicketReviewComment(reviewId: number, commentId: number, data: CommentCreateInterface): Promise<void>;

  deleteChatReviewComment(reviewId: number, commentId: number): Promise<void>;

  deleteTicketReviewComment(reviewId: number, commentId: number): Promise<void>;

  /// FEEDBACK
  createChatFeedbackComment(feedbackId: number, data: CommentCreateInterface): Promise<FeedbackCommentInterface>;

  createTicketFeedbackComment(feedbackId: number, data: CommentCreateInterface): Promise<FeedbackCommentInterface>;

  updateChatFeedbackComment(feedbackId: number, commentId: number, data: CommentCreateInterface): Promise<void>;

  updateTicketFeedbackComment(feedbackId: number, commentId: number, data: CommentCreateInterface): Promise<void>;

  deleteChatFeedbackComment(feedbackId: number, commentId: number): Promise<void>;

  deleteTicketFeedbackComment(feedbackId: number, commentId: number): Promise<void>;

  /// TICKET
  createTicketComment(id: number, data: CommentCreateInterface): Promise<TicketCommentInterface>;

  updateTicketComment(ticketId: number, commentId: number, data: CommentCreateInterface): Promise<void>;

  deleteTicketComment(ticketId: number, commentId: number): Promise<void>;

  /// REPLY
  createReplyComment(replyId: number, data: CommentCreateInterface): Promise<ReplyCommentInterface>;

  updateReplyComment(messageId: number, commentId: number, data: CommentCreateInterface): Promise<void>;

  deleteReplyComment(replyId: number, commentId: number): Promise<void>;
}
